function AddInternalNotePanelCtrl($scope, $panelInstance, venue, date, note, colorService, internalNoteService, alertService, sdkUtils, $timeout, organizationService, dateUtilsService) {
  const currentUserOrganization = organizationService.getCurrentOrganization();

  _initScope();

  function _initScope() {
    $scope.note = note;
    $scope.loading = false;
    $scope.venue = venue;
    $scope.venueBrandColors = $scope.venue.branding ? {
      primaryColor: $scope.venue.branding.primaryColor ? colorService.rgbToHex($scope.venue.branding.primaryColor.red, $scope.venue.branding.primaryColor.green, $scope.venue.branding.primaryColor.blue) : null //eslint-disable-line
    } : {};
    $scope.date = date;
    $scope.addInternalNoteForm = {
      text: $scope.note ? $scope.note.text : null
    };

    $scope.closePanel = function ($event) {
      if ($event) $event.preventDefault();

      $panelInstance.close(false);
    };

    $timeout(() => {
      $scope.giveFocus = true;
    }, 100);

    $scope.addOrUpdateNote = function (angularForm, $event) {
      if ($event) $event.preventDefault();

      if (!angularForm.$valid) return;

      const promise = $scope.note ? internalNoteService.updateById($scope.note.id, {
        text: $scope.addInternalNoteForm.text
      }) : internalNoteService.create({
        venueId: $scope.venue.id,
        organizationId: currentUserOrganization.id,
        text: $scope.addInternalNoteForm.text,
        date: dateUtilsService.toUTCTimestampWithoutTime($scope.date)
      });

      promise
        .then(result => {
          $panelInstance.close({
            added: $scope.note ? false : true, //eslint-disable-line
            note: result
          });
        })
        .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)));
    };
  }
}

AddInternalNotePanelCtrl.$inject = [
  '$scope',
  '$panelInstance',
  'venue',
  'date',
  'note',
  'colorService',
  'jsSdk.internalNote',
  'alertService',
  'jsSdk.utils',
  '$timeout',
  'organizationService',
  'dateUtilsService'
];


export default AddInternalNotePanelCtrl;



// WEBPACK FOOTER //
// ./src/panels/addInternalNote/controller.js